import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function PhilosophyPage() {
  return (
    <div className="pt-16 md:pt-20 min-h-screen bg-white" data-testid="philosophy-page">
      {/* Back Link */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors duration-200"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Home</span>
        </Link>
      </div>

      {/* PURPOSE Section */}
      <section className="py-24 md:py-40 border-b border-gray-100" data-testid="purpose-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl">
            <p className="font-en text-sm font-semibold text-[#FF4D00] tracking-widest mb-8">
              PURPOSE
            </p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-12">
              ひとつのマッチが、<br />
              未来に火を灯す。
            </h1>
            <p className="font-en text-base md:text-lg text-gray-500 mb-8">
              One Match Lights the Future.
            </p>
            <div className="space-y-6">
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                挑戦者にWinを届けるために。
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                テクノロジーと感性で、心が燃える事業を生み出す。
              </p>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                そのために私たちは、<br />
                相手ファースト×スピード×しくみで着火し、<br />
                ひとつの事業から、この国に大きな炎を灯し続ける。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION Section */}
      <section className="py-24 md:py-32 border-b border-gray-100" data-testid="mission-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl md:ml-auto md:text-right">
            <p className="font-en text-sm font-semibold text-[#FF4D00] tracking-widest mb-8">
              MISSION
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              挑戦者にWinを。
            </h2>
          </div>
        </div>
      </section>

      {/* VISION Section */}
      <section className="py-24 md:py-32 border-b border-gray-100" data-testid="vision-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl">
            <p className="font-en text-sm font-semibold text-[#FF4D00] tracking-widest mb-8">
              VISION
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              テクノロジーと感性で、<br />
              心が燃える事業を。
            </h2>
          </div>
        </div>
      </section>

      {/* VALUE Section */}
      <section className="py-24 md:py-32" data-testid="value-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="font-en text-sm font-semibold text-[#FF4D00] tracking-widest mb-12">
            VALUE
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            <div className="space-y-4">
              <div className="w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center">
                <span className="text-[#FF4D00] font-bold font-en">01</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                相手ファーストで着火する
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                自己満ではなく、<br />
                相手の着火材（ニーズ等）を探す。
              </p>
            </div>

            <div className="space-y-4">
              <div className="w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center">
                <span className="text-[#FF4D00] font-bold font-en">02</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                スピードで着火する
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                熱が冷める前に、<br />
                即レス・即行動。
              </p>
            </div>

            <div className="space-y-4">
              <div className="w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center">
                <span className="text-[#FF4D00] font-bold font-en">03</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                しくみで着火する
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                人を責めず、<br />
                ルールや構造で解決する。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
